<template>
  <div class="update-uploaded-file-overlay width margin-left-3Perc container-fluid">
    <div id="myNav" class="overlay overlay-overall-width-100Perc">
      <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div class="text-right close-text-font-style margin-right-1Perc cursor-pointer" v-on:click="closeOverlay($event)">
              <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-1Perc float-right" alt="close-icon">
            </div>  
          </div>
        </div>
        <div class="row vertical-align margin-top-1Perc">
          <div class="col-md-2 col-lg-2">
          </div>
          <div class="col-md-2 col-lg-2 font-size-16px text-align-right padding-right-0Perc">
            File Name
          </div>
          <div class="col-md-6 col-lg-6">
            <div class="form-group">
              <div class="col-sm-12 padding-left-0Perc">
                <input type="text" class="form-control" v-model="fileNameValue">
              </div>
            </div>
          </div>
          <div class="col-md-2 col-lg-2">
          </div>    
        </div>
        <div class="row vertical-align margin-top-3Perc">
          <div class="col-md-2 col-lg-2">
          </div>
          <div class="col-md-2 col-lg-2 font-size-16px text-align-right padding-right-0Perc">
            File
          </div>
          <div class="col-md-6 col-lg-6">
            <div class="form-group">
              <div class="col-sm-12 padding-left-0Perc">
                <input type="file" accept=".pdf,.png,.jpeg,.jpg" id="filetoupload" v-on:change="onFileSelected($event)">
              </div>
            </div>
          </div>
          <div class="col-md-2 col-lg-2">
          </div>    
        </div>
        <div class="row margin-top-3Perc">
          <div class="col-md-5 col-lg-5">
          </div>    
          <div class="col-md-2 col-lg-2">
            <button class="btn btn-primary btn-block upload-csv-overlay-button-BG black-font-color" @click="checkBeforeUpload">Update</button>
          </div>
          <div class="col-md-5 col-lg-5">
          </div>       
        </div>
        <div class="row margin-top-1Perc">
          <div class="col-md-12 col-lg-12">
          </div>    
        </div>    
      </div>
    </div> 
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>     
  </div> 
</template>
<script>
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { fileUploadService } from '@/server-util/file-upload-service'
import Loader from '@/components/dashboard/Loader'
export default {
  props: ['fileObj'],
  name: 'update-uploaded-file-overlay',
  created: function () {
    this.setDefaultValues()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      fileType: -1,
      fileName: '',
      fileId: '',
      fileUrl: ''
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader
  },
  methods: {
    onFileSelected: function (event) {
      var selectedFile = event.target.files[0]
      var selectedFileName = selectedFile.name
      selectedFileName = selectedFileName.substr(0, selectedFileName.lastIndexOf('.'))
      if (selectedFileName !== undefined) {
        this.fileName = selectedFileName
      } else {
        this.fileName = ''
      }
    },
    setDefaultValues: function () {
      this.fileName = this.fileObj.FileName
      this.fileId = this.fileObj.FileId
      this.fileUrl = this.fileObj.FileUrl
      this.FileType = this.fileObj.FileType
    },
    closeOverlay: function (event) {
      this.$emit('closeOverlay', false)
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    checkBeforeUpload: function () {
      var fileUrl = document.getElementById('filetoupload').files[0]
      if (this.fileName.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Name can\'t be empty.'
        this.fileName = this.fileObj.FileName
      } else if (fileUrl !== undefined) {
        if (!this.checkFileExtesion(document.getElementById('filetoupload').value)) {
          this.showAlertDialog = true
          this.errorMsg = 'Invalid file format selected.'
        } else {
          this.updateFile()
        }
      } else {
        this.updateFile()
      }
    },
    checkFileExtesion: function (fileName) {
      var isValidFileExt = false
      if (parseInt(this.FileType) === parseInt(constants.FileType.Image)) {
        var exts = ['.png', '.jpeg', '.jpg', '.PNG', '.JPEG', '.JPG']
        isValidFileExt = new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
        )
      } else {
        exts = ['.pdf', '.PDF']
        isValidFileExt = new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
          fileName
        )
      }
      return isValidFileExt
    },
    updateFile: function () {
      var storeObj = this.$store
      var _this = this
      var fileUrl = document.getElementById('filetoupload').files[0]
      const formData = new FormData()
      /*
      if (fileUrl !== undefined && fileUrl !== null) {
        formData.append('File', fileUrl)
      }
      */
      formData.append('FileId', this.fileId)
      formData.append('FileType', this.fileType)
      formData.append('FileName', this.fileName)
      formData.append('File', fileUrl)
      // _this.showSpinner = true
      _this.$store.state.isLoading = true
      fileUploadService
        .updateFile(
          storeObj.state.access_token,
          formData
        )
        .then(responseObj => {
          if (responseObj.status >= 200 && responseObj.status < 300) {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            // AK: Emit refresh List event (FileUploaderSearchBar file)
            _this.$emit('refreshList', true)
            // AK: Close overlay
            _this.$emit('closeOverlay', false)
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Oops! Something went wrong. Please try again.'
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }
        }, errorObj => {
          // AK: Hide Spinner if error occured
          // _this.showSpinner = false
          _this.$store.state.isLoading = false
          this.showAlertDialog = true
          if (errorObj.response === undefined) {
            this.errorMsg = constants.No_Internet_Connection_Msg
          } else {
            this.errorMsg = errorObj.response.statusText
          }
        })
    }
  },
  computed: {
    fileNameValue: {
      get: function () {
        console.log(JSON.stringify(this.fileObj))
        return this.fileName
      },
      set: function (newvalue) {
        this.fileName = newvalue
      }
    }
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.icon-width-height {
  width: 40px;
  height: 40px;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}

.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-16px {
  font-size: 16px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5%;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.margin-top-5Perc {
  margin-top: 5%;
}
.float-right {
  float: right;
}
.upload-csv-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}

.btn-text-color {
  color: #2c3e50;
}
.text-decoration-none {
  text-decoration: none !important;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a {
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a {
  font-size: 14px !important;
}
.border-red {
  border: 1px solid red;
}
.padding-left-0Perc {
  padding-left:0%;
}
.padding-right-0Perc {
  padding-right:0%;
}
</style>


// WEBPACK FOOTER //
// src/components/UpdateUploadedFileOverlay.vue